











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LanguageInfo extends Vue {
  @Prop({ default: [] }) languages: string[];
}
